import { render, staticRenderFns } from "./registroPartidasContables.vue?vue&type=template&id=d11286e0&lang=pug&"
import script from "./registroPartidasContables.vue?vue&type=script&lang=js&"
export * from "./registroPartidasContables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports